import { EllipsisOutlined } from '@ant-design/icons';
import { Button, Dropdown, message } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import type Asset from 'stores/Asset';
import store from 'stores/RootStore';
import { arrayMapFilter } from 'utils/Array';
import { offerDownload } from 'utils/Download';

const Container = styled.div`
  align-items: center;
  display: flex;
  gap: 7px;
`;

export interface FileRowButtonsProps {
  asset: Asset;
  selected: boolean;
}

function buildAnimationShareUrl(animation: {
  url: string;
  currentAnimationAsset: Asset | undefined;
}) {
  const shareUrl = new URL(animation.url, window.location.origin);
  const storageFilename = animation.currentAnimationAsset?.storageFilename;

  shareUrl.pathname = shareUrl.pathname.replace(/^\/view\//, '/preview/');
  shareUrl.searchParams.set('file', storageFilename || '');

  return shareUrl.href;
}

function FileRowButtons({ asset, selected }: FileRowButtonsProps) {
  const menuItemSeed = [
    {
      label: 'Restore',
      present: !selected,
      onClick: () => store.animation?.setCurrentAnimation(asset.id),
      enabled: !!store.animation,
    },
    {
      label: 'Download',
      present: true,
      onClick: () => offerDownload(asset.downloadURL, asset.filename),
      enabled: true,
    },
    {
      label: 'Remove',
      present: true,
      onClick: () => store.animation?.assets.remove(asset.id),
      enabled: !!store.animation,
    },
    {
      label: 'Copy Share Link',
      present: true,
      onClick: async () => {
        if (store.animation) {
          const shareUrl = buildAnimationShareUrl(store.animation);
          await navigator.clipboard.writeText(shareUrl);
          message.success('Share link copied.');
        }
      },
      enabled: !!store.animation,
    },
  ];

  const menuItems = arrayMapFilter(menuItemSeed, (s) => {
    if (!s.present) return undefined;
    return {
      label: s.label,
      key: s.label,
      onClick: s.onClick,
      disabled: !s.enabled || asset.loading,
    };
  });

  return (
    <Container>
      <Dropdown menu={{ items: menuItems }} trigger={['click']}>
        <Button icon={<EllipsisOutlined />} />
      </Dropdown>
    </Container>
  );
}

export default observer(FileRowButtons);
